import script from "./AdminConsumerListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminConsumerListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminConsumerListView.vue?vue&type=style&index=0&id=25c1fdaf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c1fdaf"]])

export default __exports__